(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('JoinController', JoinController);

	JoinController.$inject = ['$rootScope', 'userPouch', '$log', 'lodash', 'API', 'ENV', '$mdToast', '$state', '$analytics', '$window', 'Utils'];

	function JoinController($rootScope, userPouch, $log, lodash, API, ENV, $mdToast, $state, $analytics, $window, Utils) {

		/* jshint validthis: true */
		var self = this;

		self.user = {
			_id: '',
			password: '',
			metadata: {
				email: null,
				coupon: null,
				giftcode: null,
				billing: null
			}
		};

		// error message
		self.message = '';

		self.register = register;

		self.pay = pay;

		self.trackEvent = trackEvent;

		self.stripeKey = ENV.STRIPE_KEY;

		// set when plan's radio is selected
		self.selectedPlan = null;

		// available plans to populate radio group
		self.availablePlans = [
			{
				label: "$10/mo",
				price: "10",
				plan_description: "Up to 500 unique wines. For the connoisseur.",
				plan_name: "Third Growth",
				plan_code: "third_growth"
			},
			{
				label: "$20/mo",
				price: "20",
				plan_description: "Up to 1,000 unique wines. For the collector.",
				plan_name: "Second Growth",
				plan_code: "second_growth"
			},
			{
				label: "$40/mo",
				price: "40",
				plan_description: "Up to 2,000 unique wines. For the investor.",
				plan_name: "First Growth",
				plan_code: "first_growth"
			}
		];

		initialize();

		/** begin methods */

		/**
		 * setup preselected plan
		 */
		function initialize() {
			// get plan_code from url: /#/join/third_growth
			var selectedPlanCode = $state.params.plan_code;

			// if available, find matching plan and set to selected plan.
			if (selectedPlanCode) {
				self.selectedPlan = lodash.find(self.availablePlans, 'plan_code', selectedPlanCode);
			}

			$analytics.eventTrack('Viewed Join Page', {
				"plan": selectedPlanCode
			});
		}

		function pay(token){
			trackEvent('Payment Information Entered');
			self.user.metadata.billing = token;
		}

		function register(){

			// add plan to metadata
			self.user.metadata.plan = self.selectedPlan;

			if (lodash.get(self.user, 'metadata.coupon')){
				// force coupons to uppercase
                self.user.metadata.coupon = self.user.metadata.coupon.toUpperCase();
			}

			API.register(self.user).then(function(response){

				$log.debug('API register response', response);

				fireConversions();

				$rootScope.$emit('UserHasJoined', {user: lodash.omit(self.user, 'password')});

				self.user.active = true;

				$log.debug('Putting new user locally...', self.user);

                return userPouch
                    .login(self.user._id, self.user.password)
                    .catch(function(err) {
						$log.error('Error logging in:', err.message);
                        Utils.go('wines');
                    })
                    .then(function(response){
                        return userPouch.remote().getUser(self.user._id)
                            .catch(function(err){
                                $log.error('err getting user meta', err);
                            });
                    })
                    .then(function(response){

                        var user = angular.fromJson(response);

                        $log.debug('Login complete', user);

                        window.Intercom('update', { actual_type: 'user' });
                        window.Intercom('trackEvent', 'launch-joined');

                        $log.debug('Redirecting to wines');

                        Utils.go('wines');

                        $mdToast.show(
                            $mdToast.simple()
                                .content('Welcome back ' + lodash.get(user, 'metadata.billing.card.name', user.name) + '!')
                                .position("top right")
                                .hideDelay(5000)
                        );
                    });

			}).catch(function(response){
				self.message = response.data.error;
			});

		}

		/**
		 * trackEvent
		 *
		 * quick event tracking
		 */
		function trackEvent(eventName) {

			if (ENV.NAME != 'production'){
				return false;
			}

			var planName = lodash.get(self.selectedPlan, 'plan_name');

			$log.debug('Analytic event: ', eventName, ' - ', planName);

			$analytics.eventTrack(eventName, {
				"plan": planName
			});
		}

		function fireConversions(){

			if (ENV.NAME != 'production'){
				return false;
			}

			var planName = lodash.get(self.selectedPlan, 'plan_name');
			var planPrice = lodash.get(self.selectedPlan, 'price');
			var planValue = planPrice * 12;

			$analytics.eventTrack('User Joined', {
				"plan": planName
			});

			$window._pq = $window._pq || [];

			$window._pq.push(['track', 'Joined', {
				"revenue": planValue,
				"orderId": lodash.get(self.user, '_id')
			}]);

			$window.google_trackConversion({
				google_conversion_id : 862211915,
				google_conversion_language : "en",
				google_conversion_format : "3",
				google_conversion_color : "ffffff",
				google_conversion_label : "q1h_CKD06m0Qy56RmwM",
				google_conversion_value : planValue,
				google_remarketing_only : false
			});

			return true;
		}

	}

})();
